import { createUseMutationHook } from 'hooks/createUseMutationHook';

export const useSignConsent = createUseMutationHook('sign_consent',
    () => [
        ['auth_meta'],
    ],
);
